import { render, staticRenderFns } from "./TLSMarkerScoreCard.vue?vue&type=template&id=365af44e&scoped=true&"
import script from "./TLSMarkerScoreCard.vue?vue&type=script&lang=js&"
export * from "./TLSMarkerScoreCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365af44e",
  null
  
)

export default component.exports